module.exports = function getResource(label, vars = []) {
    const resources = { title: 'Récompenses Beauty Insider' };

    return resources[label];
};
